module.exports = __webpack_public_path__ + "img/team-3.2d391370.jpg";